export default __webpack_public_path__ + "media/images/react_icons/doorman-24h-48d332878914e9b73b9945ad0b7ff23d.svg";